<template>
    <div class="position-papers card h-auto card-filled">
        <div class="card__text h-100 justify-content-center px-2 py-2">
            <ul class="p-0 list-unstyled">
                <li v-for="(paper, index) in papers" :key="index" class="mb-4">
                    <a :href="paper.url" target="_blank" :alt="paper.name">{{
                        paper.name
                    }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        papers: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    data() {
        return {};
    }
};
</script>

<style lang="scss">
.position-papers a {
    color: $brand-green;
    border-bottom: 1px solid;
}
</style>
